import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  TextField,
  DialogActions,
} from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../../../lib/designSystem/Button';
import { loggerDev } from '../../../../../../../../../../lib/functions/utils';
import { completeCollectionManagement } from '../../../../../../../../../../lib/api/collections';
import { showAlert } from '../../../../../../../../../../lib/functions/utils';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../lib/designSystem/CircularProgress';

interface propsType {
  setDescription: any;
  description: string;
  open: boolean;
  setOpen: any;
  openEditManagementId: number;
  possiblePaymentDate: string;
  setPossiblePaymentDate: any;
  setConfirmDialogTitle: any;
  setConfirmDialogDescription: any;
  setConfirmAction: any;
  setButtonColor: any;
  setConfirmDialogOpen: any;
}

const EditManagement: React.FC<propsType> = (props: propsType) => {
  const {
    setDescription,
    description,
    possiblePaymentDate,
    setPossiblePaymentDate,
    open,
    setOpen,
    openEditManagementId,
    setConfirmDialogTitle,
    setConfirmDialogDescription,
    setConfirmAction,
    setButtonColor,
    setConfirmDialogOpen,
  } = props;

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleConfirmCompleteDialog = (id: number) => {
    setConfirmDialogTitle('Completar gestión ' + `#${id}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas completar la gestión?',
    );
    setConfirmAction(() => async () => await handleCompleteFinal(id)); // Corregido
    setButtonColor('primary');
    setConfirmDialogOpen(true);
  };

  const handleCompleteFinal = async (id: number) => {
    if (!id) return;

    setConfirmDialogOpen(false);
    setLoading(true);
    try {
      await completeCollectionManagement(dispatch, id, {
        newDescription: description,
        possiblePaymentDate: possiblePaymentDate,
      });
      showAlert(dispatch, 'success', 'Gestión completada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al completar la gestión');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Editar gestión</DialogTitle>
      {loading ? (
        <div style={{ minHeight: 200 }}>
          <CenteredCircularProgress type="dialog" />
        </div>
      ) : (
        <>
          <DialogContent>
            <Typography marginBottom={2}>
              Si quieres puedes editar la descripción de la gestión para que
              quede completada con la nueva información
            </Typography>
            <TextField
              fullWidth
              multiline
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <TextField
              style={{ marginTop: 8 }}
              id="outlined-basic-two"
              label="Posible fecha de pago"
              variant="outlined"
              type="date"
              value={possiblePaymentDate}
              fullWidth
              onChange={(e) => {
                setPossiblePaymentDate(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <CustomButton color="secondary" onClick={() => setOpen(false)}>
              Cancelar
            </CustomButton>
            <CustomButton
              onClick={() => handleConfirmCompleteDialog(openEditManagementId)}
            >
              Avanzar
            </CustomButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default EditManagement;
